import { STORE_TRANSLATIONS, STORE_LOCALE, STORE_AVAILABLE_LOCALES } from '../actions/i18n';

const i18n = (state = {
  locale: 'en-GB',
}, action) => {
  switch (action.type) {
    case STORE_TRANSLATIONS: {
      const { translations } = action;
      return {
        ...state,
        translations,
      };
    }

    case STORE_LOCALE: {
      const { locale } = action;
      return {
        ...state,
        locale,
      };
    }

    case STORE_AVAILABLE_LOCALES: {
      const { locales } = action;
      return {
        ...state,
        locales,
      };
    }

    default:
      return state;
  }
};

export default i18n;
